(function () {
	window.js = window.js || {};
	js.article = (function () {
		function initialize(domElm) {
			var images = Array.prototype.slice.call(domElm.querySelectorAll('img[title]')),
				innerImages = Array.prototype.slice.call(domElm.querySelectorAll('img')),
		        mainContent = document.querySelectorAll('.article__content-column'),
		        aside = document.querySelectorAll('.article__content-column.last');
            
			images.forEach(function (image) {
				var parent = image.parentNode;
				var figure = document.createElement('figure');
				var caption = document.createElement('figcaption');
				caption.innerText = image.alt;

				if (image.classList.contains('-left')) {
					image.classList.remove('-left');
					figure.classList.add('-left');
				}

				parent.removeChild(image);
				figure.appendChild(image); 
				figure.appendChild(caption);
				parent.appendChild(figure);
			}); 

			innerImages.forEach(function (image) {
				if (image.style.float) {
					if (image.style.float == "left") {
						image.classList.add("-float-left")
					} else if (image.style.float == "right") {
						image.classList.add("-float-right")
                    }
                }
            })

            if (aside.length) {
                var oElm = aside[0].children[0],
                    nLastPos = scrollPosition(),
                    nScrollPos = scrollPosition(),
                    oHeader = document.getElementById('header'), 
                    oHeaderHeight = parseFloat(window.getComputedStyle(oHeader, null).getPropertyValue('height'));

                window.addEventListener("scroll", throttle(function () {
                    var oClientRect = document.getElementsByClassName('article__content')[0].getBoundingClientRect(), oTop = oClientRect.top, oBottom = oClientRect.bottom,
                        isInsideMediaQuery = window.matchMedia('(max-width: 1023px)').matches;

                    if (parseFloat(window.getComputedStyle(mainContent[0].children[0], null).getPropertyValue('height')) < parseFloat(window.getComputedStyle(oElm, null).getPropertyValue('height'))) {
                        return false;
                    } else if (isInsideMediaQuery) { // Orientation change: Check MQ to see if we should adjust something?
                        oElm.classList.remove('sticky', 'sticky--out');
                        oElm.removeAttribute('style');
                    } else {
                        // Watchers
                        if (oTop < 10) {
                            oElm.style.width = oElm.parentElement.clientWidth + "px";
                            oElm.classList.add('sticky'); 
                        }

                        if (oBottom < oElm.offsetHeight) {
                            oElm.classList.add('bottom');
                        } else {
                            oElm.classList.remove('bottom');
                        }

                        if (oTop > oHeaderHeight) {
                            oElm.classList.remove('sticky', 'sticky--out');
                        }
                    }
                    nLastPos = nScrollPos;
                }, 150));        
            }
		}

        
	    function scrollPosition() {
	        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
        }

	    function throttle(fn, threshhold, scope) {
	        threshhold = typeof threshhold !== "undefined" ? threshhold : 250;
	        var
	            last,
	            deferTimer;
	        return function () {
	            var
	                context = scope || this,
	                now = +new Date(),
	                args = arguments;
	            if (last && now < last + threshhold) {
	                clearTimeout(deferTimer);
	                deferTimer = setTimeout(function () {
	                    last = now;
	                    fn.apply(context, args);
	                }, threshhold);
	            } else {
	                last = now;
	                fn.apply(context, args);
	            }
	        };
        }

		return {
			initialize: initialize
		};
	})();
})();